function number2ordinal(number) {
	const pr = new Intl.PluralRules("en-US", { type: "ordinal" });

	const suffixes = new Map([
		["one", "st"],
		["two", "nd"],
		["few", "rd"],
		["other", "th"],
	]);

	const rule = pr.select(number);
	const suffix = suffixes.get(rule);
	return `${number}${suffix}`;
}

function numberSuffix(number) {
	const pr = new Intl.PluralRules("en-US", { type: "ordinal" });
	const suffixes = new Map([
		["one", "st"],
		["two", "nd"],
		["few", "rd"],
		["other", "th"],
	]);
	const rule = pr.select(number);
	return suffixes.get(rule);
}

function getCurrencySymbol() {
	return "$";
}

function getFormatAmount(number, decimals = 2) {
	try {
		const composed = parseFloat(number).toFixed(decimals).toString().split(".");
		composed[0] = composed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return composed.join(".");
	} catch (error) {
		console.log(error);
	}

	return number;
}

function accountFormat(number, decimals = 2) {
	return isNumber(number) ? getFormatAmount(number, decimals) : "-";
}

const unformattedAmount = (number = "") => {
	if (number) {
		return number.toString().replace(/,/g, "");
	}
	return number;
};

const formatNumber = (region, options, value) => new Intl.NumberFormat(region, options).format(value);
// Receives a number and returns its variant formatted with just the first 2
// E.g: 5000 |-> 5k; 2500 |-> 2.5k
const firstRegularNumbers = (number) => {
	const result = number / 1000;
	return result.toFixed(Number.isInteger(result) ? 0 : 1) + "k";
};

function insertCommas(numStr) {
	const parts = numStr.split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	return parts.join(".");
}

function numberToReadableFormat(num) {
	const numCopy = Math.abs(num);
	const [strNum] = numCopy.toString().split(".");

	let formattedNumber;

	if (!numCopy) {
		return "0";
	}

	switch (true) {
		case numCopy >= 1_000_000:
			const formatted = (numCopy / 1000000).toFixed(2);
			formattedNumber = insertCommas(formatted) + "M";
			break;
		case numCopy >= 1000:
			formattedNumber = insertCommas(strNum) + "k";
			break;
		default:
			formattedNumber = insertCommas(strNum);
			break;
	}

	if (Math.sign(num) === -1) {
		formattedNumber = `-${formattedNumber}`;
	}

	return formattedNumber;
}

function isNumber(value) {
	let valueString = String(value);
	while (valueString.includes(",")) {
		valueString = valueString.replace(",", "");
	}
	return !isNaN(Number(valueString));
}

function isNegative(value) {
	return isNumber(value) && Math.sign(Number(value)) === -1;
}

function isNegativeFormatted(value) {
	if (typeof value === "string") {
		return value.startsWith("(") || value.startsWith("-");
	}
	return isNegative(value);
}

export {
	number2ordinal,
	numberSuffix,
	getCurrencySymbol,
	getFormatAmount,
	accountFormat,
	unformattedAmount,
	formatNumber,
	firstRegularNumbers,
	numberToReadableFormat,
	isNegative,
	isNumber,
	isNegativeFormatted,
};
